import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionCta } from '../components/SectionCta';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-14 sm:py-20" aria-labelledby="faq-heading" data-id="element-152" data-mp="1qlnwre88igfu">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-153" data-mp="1lnw2idk4ai8h">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600" data-id="element-154" data-mp="1ll9nxtyt72gr">
          Frequently asked questions
        </p>
        <h2 id="faq-heading" className="mx-auto mt-3 max-w-xl text-center font-display text-[26px] font-black leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-155" data-mp="1bq7vop98lk9y">
          Everything you might be wondering
        </h2>

        <div className="mt-9 divide-y divide-navy-900/10 overflow-hidden rounded-2xl border border-navy-900/10" data-id="element-156" data-mp="321vyjdfudnqg">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.question} data-id="element-157" data-mp="v8k16v008hcv" data-mpi={i}>
                <h3 data-id="element-158" data-mp="v9llzr6toi7s">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-brand-50 sm:px-5" data-id="element-159" data-mp="v5xvz20l6dxt">
                    <span className="text-[14.5px] font-bold leading-snug text-navy-900 sm:text-base" data-id="element-160" data-mp="1dxgvuzzbdbvm">
                      {faq.question}
                    </span>
                    <ChevronDownIcon aria-hidden="true" className={`mt-0.5 h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-161" data-mp="148gtr7pim0d7" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-162" data-mp="26jp2bran4ucq">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-163" data-mp="22kg7ej3v6qfl">
                      <p className="px-4 pb-5 text-[14px] leading-relaxed text-ink-700 sm:px-5 sm:text-[15px]" data-id="element-164" data-mp="1ivfiguwzmgo8">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCta label="I’m ready — give me access" data-id="element-165" data-mp="14w631xglvqlb" />
      </div>
    </section>;
}